const DriverMonitoringError = () => {
  return (
    <div className='flex flex-col items-center justify-center w-full h-full'>
      <div className='text-center'>
        <p className='text-xl font-semibold text-red-600 mb-2'>
          Error al cargar conductores
        </p>
        <p className='text-sm text-gray-500'>
          No se pudo conectar con el servidor. Por favor, intenta más tarde.
        </p>
      </div>
    </div>
  );
};

export default DriverMonitoringError;
